import { colors } from '../../theme'
import { Icon, symbolName } from './Icon'

type PrivacyPolicyIconProps = Readonly<{
  size?: number
  color?: string
}>

export function PrivacyPolicyIcon({
  size = 24,
  color = colors.inkSecondary,
}: PrivacyPolicyIconProps) {
  return (
    <Icon
      name={symbolName('checkmark.shield', 'verified_user')}
      size={size}
      color={color}
    />
  )
}
